import React, { Component } from "react";
import { connect } from "react-redux";
import BigCalendar from "react-big-calendar";
import ContentHeader from "./ContentHeader";
import moment from "moment";
import { newEvent, editEvent, hideModal } from "../actions/events";
import EventModal from "./EventModal";
import { list, create, update } from "../actions";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

const EventsCalendar = props => {
  const { events, onSelectEvent } = props;
  return (
    <div className="calendar-container">
      <BigCalendar
        selectable
        views={["month", "week", "day"]}
        events={events}
        defaultView="week"
        defaultDate={new Date()}
        onSelectEvent={event => onSelectEvent(event)}
      />
    </div>
  );
};

class Events extends Component {
  componentDidMount() {
    this.props.fetchEvents();
    this.props.fetchAssets();
  }
  render() {
    return (
      <div>
        <ContentHeader title="Events">
          <span className="pull-right">
            <button className="btn btn-primary" onClick={this.props.newEvent}>
              Add Event
            </button>
          </span>
        </ContentHeader>

        <EventsCalendar
          events={this.props.events}
          onSelectSlot={this.props.newEvent}
          onSelectEvent={this.props.editEvent}
        />
        <EventModal
          showModal={this.props.showEventModal}
          hideModal={this.props.hideModal}
          saveEvent={this.props.saveEvent}
          currentEvent={this.props.currentEvent}
          preachers={this.props.preachers}
          assets={this.props.assets}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { list, currentEvent, showEventModal } = state.events;
  return {
    assets: state.assets.list,
    events: list,
    currentEvent: currentEvent,
    showEventModal: showEventModal,
    preachers: state.preachers.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchEvents() {
      dispatch(list("events"));
    },
    fetchAssets() {
      dispatch(list("assets"));
    },
    newEvent(eventDetails) {
      dispatch(newEvent(eventDetails));
    },
    editEvent(eventDetails) {
      dispatch(editEvent(eventDetails));
    },
    hideModal() {
      dispatch(hideModal());
    },
    saveEvent(data) {
      if (data.id) {
        dispatch(update("event", data));
      } else {
        dispatch(create("event", data));
      }
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Events);



// WEBPACK FOOTER //
// ./src/components/Events.js